import React, { memo, useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import ButtonComponent from "../button";
import { LinearProgress } from "@mui/material";
import RadioComponent from "../evaluation-form-components/radio";
import GenderComponent from "../evaluation-form-components/gender";
import CheckComponent from "../evaluation-form-components/check";
import Rating5Component from "../evaluation-form-components/rating_5";
import Rating10Component from "../evaluation-form-components/rating_10";
import TextAreaComponent from "../evaluation-form-components/textarea";
import DropdownEvaluatorComponent from "../evaluation-form-components/dropdown-evaluator";

const Container = styled.div`
    width: 100%;
    /* height: 100%; */
`;

const Banner = styled.div`
    width: calc(100% - 32px);
    height: 122px;
    background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);
    display: flex;
    padding: 0px 16px;

    .label {
        width: 100%;
        color: #25368D;
        font-size: 20px;
        font-weight: 600;
        line-height: 29.9px;
        text-align: left;
    }

`;

const Body = styled.div`
    width: calc(100% - 48px);
    /* height: calc(100% - 150px); */
    padding: 0px 24px 24px 24px;
    display: flex;
    flex-direction: column;

    .description {
        color: #2A2A2A;
        font-size: 20px;
        font-weight: 400;
        line-height: 29.9px;
        text-align: left;
        margin-bottom: 4px;
    }
    .title {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 12px;
    }
    .group-title {
        color: #505050;
        font-size: 14px;
        font-weight: 300;
        line-height: 20.93px;
        text-align: left;
        margin-bottom: 12px;
    }
`;

const StepBox = styled.div`
    width: 100%;
    height: 82px;
    margin: 8px 0px 18px 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .sb-label {
        color: #505050;
        font-size: 14px;
        font-weight: 300;
        line-height: 20.93px;
        text-align: left;
    }

    .sb-title {
        color: #505050;
        font-size: 14px;
        font-weight: 300;
        line-height: 20.93px;
        text-align: left;
    }

    .sb-progress {
        
    }
`;

const QuestionBox = styled.div`
    margin-bottom: 16px;

    &.hidden {
        display: none;
    }
`;

function EvaluationFormLayout({
    back,
    onBack,
    onNext,
    evaluationFormData,
    detailPageForm,
    onUpdateEvaluationFormData,
    evaluationFormHistory,
    onUpdateEvaluationFormHistory,
    onEndEvaluationForm,
}) {
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [currentShow, setCurrentShow] = useState([]);
    const [formType, setFormType] = useState("");
    const [groupTitle, setGroupTitle] = useState("");
    const [groupIndex, setGroupIndex] = useState(0);
    const [subFormIndex, setSubFormIndex] = useState(0);
    const [totalGroup, setTotalGroup] = useState(1);
    const [totalSubForm, setTotalSubForm] = useState(1);
    const [disableButton, setDisableButton] = useState(false)

    useEffect(() => {
        if (back) {
            let backParam = "";
            let _currentPage = currentPage;
            let _groupIndex = groupIndex;
            let _subFormIndex = subFormIndex;
            if (currentPage === 1 && groupIndex === 0 && subFormIndex === 0) {
                backParam = "first_form"
            } else {
                let historyId = `${currentPage},${groupIndex},${subFormIndex}`;
                let index = evaluationFormHistory?.findIndex(x => x.id === historyId);
                if (index > 0) {
                    let model = evaluationFormHistory[index - 1];
                    onSetEvaluationFormData(data, model.page, model.groupIndex, model.subFormIndex)
                    _currentPage = model.page;
                    _groupIndex = model.groupIndex;
                    _subFormIndex = model.subFormIndex;
                    setCurrentPage(_currentPage)
                    setGroupIndex(_groupIndex);
                    setSubFormIndex(_subFormIndex);
                }
            }
            onBack && onBack(backParam, {
                currentPage: _currentPage,
                groupIndex: _groupIndex,
                subFormIndex: _subFormIndex,
            })
        }
    }, [back])

    useEffect(() => {
        if (evaluationFormData) {
            let detail = {
                currentPage: detailPageForm?.currentPage || 1,
                groupIndex: detailPageForm?.groupIndex || 0,
                subFormIndex: detailPageForm?.subFormIndex || 0,
            }
            onSetEvaluationFormData(evaluationFormData, detail.currentPage, detail.groupIndex, detail.subFormIndex)
            setCurrentPage(detail.currentPage)
            setGroupIndex(detail.groupIndex);
            setSubFormIndex(detail.subFormIndex);
        }
    }, [])

    useEffect(() => {
        const checkValidate = onCheckValidate();
        if (checkValidate !== disableButton) {
            setDisableButton(checkValidate)
        }
    }, [data, currentShow])

    function onSetEvaluationFormData(param, page, group_index, sub_form_index) {
        if (Array.isArray(param?.evaluation_form)) {
            const _totalPage = param.evaluation_form?.length || 1;
            setTotalPage(_totalPage);
            const model = param?.evaluation_form.find(x => x.page === page);
            if (model) {
                let form = [];
                let _groupTitle = "";
                if (model.form_type === "single_level") {
                    form = model.form;
                } else if (model.form_type === "group_level") {
                    if (Array.isArray(model.form) && model.form.length >= group_index) {
                        setTotalGroup(model.form.length)
                        let group = model.form[group_index];
                        _groupTitle = group.group;
                        if (group.group_type === "sub_form" && Array.isArray(group.form)) {
                            let subForm = group.form[sub_form_index]
                            setTotalSubForm(group.form.length)
                            const title = subForm.title;
                            form = subForm.form.map((value) => {
                                let detail = {
                                    ...value,
                                    sub_title: value.title
                                }
                                detail.title = title;
                                return detail;
                            })
                        }
                    }
                }
                form = form.map((value) => {
                    if (value.type === "rating_5") {
                        value.answer = value.answer || 5
                    } else if (value.type === "rating_10") {
                        value.answer = value.answer || 10
                    }
                    return value
                })
                if (model.form_type === "single_level") {
                    if (Array.isArray(form)) {
                        for (let i = 0; i < form.length; i++) {
                            if (form[i].answer !== undefined && model.form[i].answer !== undefined) {
                                model.form[i].answer = form[i].answer
                            }
                        }
                    }
                } else {
                    if (model.form?.length > group_index) {
                        if (model.form[group_index].form?.length > sub_form_index) {
                            if (Array.isArray(form)) {
                                for (let i = 0; i < form.length; i++) {
                                    if (form[i].answer !== undefined && model.form[group_index].form[sub_form_index].form[i].answer !== undefined) {
                                        model.form[group_index].form[sub_form_index].form[i].answer = form[i].answer
                                    }
                                }
                            }
                        }
                    }
                }
                // ========== ========== ========== ==========
                const modelEvaluatorType = form?.find(x => x.tag === "ประเภทผู้ประเมิน");
                if (modelEvaluatorType) {
                    const indexSportCategory = form?.findIndex(x => x.tag === "ประเภทกีฬา");
                    if (indexSportCategory >= 0) {
                        let hidden = true;
                        if (modelEvaluatorType?.answer?.value === "นักกีฬา") {
                            hidden = false;
                        }
                        if (hidden) {
                            form[indexSportCategory].answer = null;
                        }
                        form[indexSportCategory].hidden = hidden;
                    }
                }
                // ========== ========== ========== ==========
                setCurrentShow(form)
                setFormType(model.form_type);
                setGroupTitle(_groupTitle);
                let history = [...evaluationFormHistory];
                let historyId = `${page},${group_index},${sub_form_index}`;
                const modelHistory = history.find(x => x.id === historyId);
                if (!modelHistory) {
                    history.push({
                        id: historyId,
                        form: form,
                        page: page,
                        groupIndex: group_index,
                        subFormIndex: sub_form_index,
                    })
                }
                onUpdateEvaluationFormHistory && onUpdateEvaluationFormHistory(history);
            }
        }
        setData(param)
    }
    function onCheckValidate() {
        let check = false;
        let list = currentShow.filter(x => {
            let check = false;
            if (x.required) {
                if (!x.answer || (Array.isArray(x.answer) && x.answer.length === 0)) {
                    check = true;
                }
            }
            return check;
        });
        if (list.length > 0) {
            check = true;
            list = list.map(value => value.title)
        }
        return check;
    }
    function onSetSubTitleStepBox() {
        let text = "";
        if (Array.isArray(data?.evaluation_form)) {
            const model = data?.evaluation_form.find(x => x.page === currentPage);
            text = model?.title || "";
        }
        return text;
    }

    function handleClickNext() {
        if (onCheckValidate()) {
            const element = document.getElementById("main-container-layout");
            if (element) {
                element.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                });
            }
            return;
        }
        let checkEnd = false;
        let n_currentPage = currentPage;
        let n_groupIndex = groupIndex;
        let n_subFormIndex = subFormIndex;
        if (formType === "single_level") {
            let page = currentPage + 1;
            if (page > totalPage) {
                checkEnd = true;
            } else {
                onSetEvaluationFormData(data, page, 0, 0)
                setCurrentPage(page)
                n_currentPage = page;
            }
            setSubFormIndex(0);
            setGroupIndex(0);
            n_groupIndex = 0;
            n_subFormIndex = 0;
        } else if (formType === "group_level") {
            let _subFormIndex = subFormIndex + 1;
            if (_subFormIndex >= totalSubForm) {
                _subFormIndex = 0;
                let _groupIndex = groupIndex + 1;
                if (_groupIndex >= totalGroup) {
                    let page = currentPage + 1;
                    if (page > totalPage) {
                        checkEnd = true;
                    } else {
                        onSetEvaluationFormData(data, page, 0, 0)
                        setCurrentPage(page)
                        n_currentPage = page;
                    }
                    setSubFormIndex(0);
                    setGroupIndex(0);
                    n_groupIndex = 0;
                    n_subFormIndex = 0;
                } else {
                    onSetEvaluationFormData(data, currentPage, _groupIndex, _subFormIndex)
                    setSubFormIndex(_subFormIndex);
                    setGroupIndex(_groupIndex);
                    n_groupIndex = _groupIndex;
                    n_subFormIndex = _subFormIndex;
                }
            } else {
                onSetEvaluationFormData(data, currentPage, groupIndex, _subFormIndex)
                setSubFormIndex(_subFormIndex);
                n_subFormIndex = _subFormIndex;
            }
        }
        if (checkEnd) {
            onEndEvaluationForm && onEndEvaluationForm(data, {
                currentPage: n_currentPage,
                groupIndex: n_groupIndex,
                subFormIndex: n_subFormIndex,
            })
        } else {
            onNext && onNext("", {
                currentPage: n_currentPage,
                groupIndex: n_groupIndex,
                subFormIndex: n_subFormIndex,
            })
        }
    }
    function handleChange(param, index) {
        let detail = {
            ...data,
        }
        let _currentShow = null;
        let indexPage = detail?.evaluation_form.findIndex(x => x.page === currentPage);
        if (indexPage >= 0) {
            if (formType === "single_level") {
                detail.evaluation_form[indexPage].form[index].answer = param;
                let _component = detail.evaluation_form[indexPage].form[index];
                if (_component?.tag === "ประเภทผู้ประเมิน") {
                    let hidden = true;
                    const indexSportCategory = detail.evaluation_form[indexPage].form?.findIndex(x => x.tag === "ประเภทกีฬา");
                    if (indexSportCategory >= 0) {
                        if (_component?.answer?.value === "นักกีฬา") {
                            hidden = false;
                        }
                        if (hidden) {
                            detail.evaluation_form[indexPage].form[indexSportCategory].answer = null;
                        }
                        detail.evaluation_form[indexPage].form[indexSportCategory].hidden = hidden;
                    }
                }
                _currentShow = detail.evaluation_form[indexPage].form[index];
            } else if (formType === "group_level") {
                detail.evaluation_form[indexPage].form[groupIndex].form[subFormIndex].form[index].answer = param
                _currentShow = detail.evaluation_form[indexPage].form[groupIndex].form[subFormIndex].form[index];
            }
        }
        if (_currentShow && Array.isArray(currentShow)) {
            let currentShowClone = JSON.parse(JSON.stringify(currentShow));
            let indexCurrentShow = currentShowClone.findIndex(x => x.title === _currentShow.title && x.sub_title === _currentShow.sub_title);
            if (indexCurrentShow >= 0) {
                currentShowClone[indexCurrentShow] = { ..._currentShow };
                if (_currentShow.tag === "ประเภทผู้ประเมิน") {
                    const indexSportCategory = currentShowClone?.findIndex(x => x.tag === "ประเภทกีฬา");
                    if (indexSportCategory >= 0) {
                        let hidden = true;
                        if (_currentShow?.answer?.value === "นักกีฬา") {
                            hidden = false;
                        }
                        if (hidden) {
                            currentShowClone[indexSportCategory].answer = null;
                        }
                        currentShowClone[indexSportCategory].hidden = hidden;
                    }
                }
                setCurrentShow(currentShowClone)
            }
        }
        setData(detail)
        onUpdateEvaluationFormData && onUpdateEvaluationFormData(detail, {
            currentPage: currentPage,
            groupIndex: groupIndex,
            subFormIndex: subFormIndex,
        });
    }

    function formatQuesionNumber(index) {
        let number = index + 1;
        let countHidden = 0;
        for (let i = 0; i < index; i++) {
            if (currentShow[i].hidden) {
                countHidden++;
            }
        }
        return number - countHidden;
    }

    return (
        <Container>
            <Banner>
                <div className="label vertical-center">{data?.title || ""}</div>
            </Banner>
            <Body>
                <StepBox>
                    <div className="sb-label">แบบสอบถามส่วนที่ {currentPage}/{totalPage}</div>
                    <LinearProgress sx={{
                        "& .MuiLinearProgress-bar": {
                            backgroundColor: "#FBE250"
                        },
                        backgroundColor: "#EBF9F9",
                    }}
                        variant="determinate"
                        value={(currentPage * 100) / totalPage} />
                    <div className="sb-title">
                        {onSetSubTitleStepBox()}
                    </div>
                </StepBox>

                {currentShow.map((value, index) => {
                    return (
                        <QuestionBoxComponent
                            key={`${currentPage}-${groupIndex}-${subFormIndex}-${index}`}
                            currentPage={currentPage}
                            groupIndex={groupIndex}
                            subFormIndex={subFormIndex}
                            formType={formType}
                            groupTitle={groupTitle}
                            value={value}
                            index={index}
                            question_number={formatQuesionNumber(index)}
                            handleChange={handleChange}
                        />
                    )
                })}


                <ButtonComponent
                    label={"ถัดไป"}
                    variant={"primary"}
                    disable={disableButton}
                    style={{ marginTop: "48px" }}
                    onClick={handleClickNext}
                />
            </Body>
        </Container>
    )
}

const QuestionBoxComponent = memo(({
    currentPage,
    groupIndex,
    subFormIndex,
    formType,
    groupTitle,
    value,
    index,
    question_number,
    handleChange
}) => {
    return (
        <QuestionBox key={`${currentPage}-${groupIndex}-${subFormIndex}-${index}`} className={`${value?.hidden ? 'hidden' : ''}`}>
            {(formType === 'group_level' && index === 0) && <div className="group-title">{groupTitle || ''}</div>}
            {(formType === 'group_level' && index === 0) &&
                <div className="title">{(subFormIndex + index) + 1}. {value.title || ''} {value.required && <span style={{ color: '#F84242' }}>*</span>}</div>
            }
            {(formType === 'single_level') &&
                <div className="title">{question_number}. {value.title || ''} {value.required && <span style={{ color: '#F84242' }}>*</span>}</div>
            }
            {formType === 'group_level' && <div className="title">{value.sub_title || ''}</div>}
            {value.type === 'radio' &&
                <RadioComponent
                    list={value.choice || []}
                    value={value.answer}
                    onSelect={(e) => handleChange(e, index)}
                />
            }
            {value.type === 'gender' &&
                <GenderComponent />
            }
            {value.type === 'check' &&
                <CheckComponent
                    list={value.choice || []}
                    value={value.answer}
                    onSelect={(e) => handleChange(e, index)}
                />
            }
            {value.type === 'rating_5' &&
                <Rating5Component
                    value={value.answer}
                    onSelect={(e) => handleChange(e, index)}
                />
            }
            {value.type === 'rating_10' &&
                <Rating10Component
                    value={value.answer}
                    onSelect={(e) => handleChange(e, index)}
                />
            }
            {value.type === 'textarea' &&
                <TextAreaComponent
                    value={value.answer}
                    placeholder={"กรุณาระบุ"}
                    onInput={(e) => handleChange(e, index)}
                />
            }
            {value.type === 'dropdown_filter' &&
                <DropdownEvaluatorComponent
                    placeholder={value.title || ''}
                    list={value.choice || []}
                    value={value.answer}
                    mode={"single"}
                    onSelect={(e) => handleChange(e, index)}
                />
            }
        </QuestionBox>
    );
});

export default EvaluationFormLayout;